import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import CButton from '@/components/shared/CButton';
import CModal from '@/components/CModal.vue';
import CInput from '@/components/shared/CInput';

type Preview = {
    label: string;
    value: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CanvasToolbarTopPreviewButtonsEditModal',
  emits: ['save'],
  setup(__props, { expose, emit }) {



const isModalOpen = ref(false);
const preview = ref({ label: '', value: '' });

const openModal = (previewData: Preview) => {
    preview.value = { ...previewData };
    isModalOpen.value = true;
};

const handleClose = () => {
    isModalOpen.value = false;
    preview.value = { label: '', value: '' };
};

const savePreview = () => {
    emit('save', preview.value);
    handleClose();
};

expose({
    openModal
});

return { __sfc: true,emit, isModalOpen, preview, openModal, handleClose, savePreview, ValidationProvider, ValidationObserver, CButton, CModal, CInput }
}

})